import React from 'react';
import { cx } from './cx';

export const tooltipPlacements = ['top', 'bottom', 'left', 'right'] as const;
export type TooltipPlacement = (typeof tooltipPlacements)[number];

interface TooltipProps {
  title?: string;
  content: React.ReactNode;
  placement?: TooltipPlacement;
  children: React.ReactNode;
}

function placementClass(placement: TooltipPlacement): string {
  switch (placement) {
    case 'top':
      return 'osrs-tooltip--top';
    case 'bottom':
      return 'osrs-tooltip--bottom';
    case 'left':
      return 'osrs-tooltip--left';
    case 'right':
      return 'osrs-tooltip--right';
    default: {
      const neverPlacement: never = placement;
      return neverPlacement;
    }
  }
}

const Tooltip: React.FC<TooltipProps> = ({
  title,
  content,
  placement = 'top',
  children,
}) => {
  return (
    <span className="osrs-tooltip-wrap">
      <span tabIndex={0}>{children}</span>
      <span role="tooltip" className={cx('osrs-tooltip', placementClass(placement))}>
        {title ? <span className="osrs-tooltip__title">{title}</span> : null}
        {title ? <br /> : null}
        <span className="osrs-tooltip__body">{content}</span>
      </span>
    </span>
  );
};

export default Tooltip;
